import { dateValidation } from "constants/dateValidation"
import {
  SheetField,
  SheetRow,
  type MappingSchemaJSON,
  type MappingSchemaJSONColumn,
  type MappingSchemaRow,
} from "interfaces/dataInterfaces"

export function jsonToRowData(data: Record<string, any>[]) {
  const rows: SheetRow[] = []
  data.forEach(row => {
    const rowData: SheetField[] = []
    Object.keys(row).forEach(key => {
      rowData.push({ value: row[key], readOnly: true })
    })
    rows.push(rowData)
  })
  return rows
}

export const buildPartialDate = (date: string, type: string, colName: string): string[] => {
  const values = date?.split("-")
  const dateTypes = ["year", "month", "day"]
  const result: string[] = []

  for (let i = 0; i < dateTypes.length; i++) {
    if (dateTypes[i] === type) {
      result[i] = colName
    } else {
      values[i] = values[i] === colName ? "" : values[i]
      result[i] = values[i] || dateTypes[i]
    }
  }
  return [result.join("-"), result[2] !== "day" ? "partial-daily" : "partial-monthly"]
}

const getPriceType = (element: MappingSchemaJSONColumn): string => {
  if (typeof element.commodity === "number" && typeof element.unit === "number") return "priceCommodityMeasure"
  if (typeof element.commodity === "number") return "priceCommodity"
  return "priceValue"
}

export const getDataType = (value: string, mapping: MappingSchemaJSON) => {
  const result: Partial<MappingSchemaRow> = {}
  const { dateFormat, columns, metadataFields } = mapping

  columns.forEach(element => {
    const keys = Object.keys(element)
    keys.forEach(key => {
      if (key === "date" && typeof element[key] === "string" && element[key].includes(value)) {
        result.dataType = dateFormat
        result.type = "date"
        result.isValid = true
        if (dateFormat === "partial-monthly") {
          result.dataType = element.date.split("-")[0] === value ? "year" : "month"
        }
        if (dateFormat === "partial-daily") {
          result.dataType =
            element.date.split("-")[0] === value ? "year" : element.date.split("-")[1] === value ? "month" : "day"
        }
      }
      if (key !== "date" && element[key] === value) {
        result.isValid = true
        switch (key) {
          case "price":
            if (element.commodity) result.commodity = element.commodity
            if (element.unit) result.unit = element.unit
            result.dataType = getPriceType(element)
            result.type = "price"
            break

          case "unit":
            result.dataType = typeof element.commodity === "number" ? "unitCommodity" : "unitName"
            result.commodity = typeof element.commodity === "number" ? element.commodity : ""
            result.type = "unit"
            break

          default:
            result.dataType = key
            result.type = key
            break
        }
      }
    })
  })

  if (metadataFields?.length && metadataFields.some(item => item.value === value)) {
    result.isValid = true
    result.dataType = "metadata"
    result.type = "metadata"
    result.value = metadataFields.find(item => item.value === value)?.fieldName
  }

  return result
}

export const validateDate = (format: string): string[] =>
  dateValidation.find(item => item.format.toLowerCase() === format.toLowerCase())?.values || []
